<template>
  <nav>
    <router-link to="/">Zurück</router-link>
  </nav>
  <router-view/>
</template>

<style lang="scss">
@import "@/assets/styles/_variables.scss";

* {
  box-sizing: border-box;
}

body{
  margin: 0;
  background-color: $bg-color;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
  text-decoration: none;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
